<div>
  <img src="data:{{displayModel?.content_type}};base64,{{displayModel?.data}}" alt=""/>
</div>
